<p-dialog
  [(visible)]="isVisible"
  [style]="{ width: '70vw' }"
  header="Sistem Log Kayıtları"
  [resizable]="true"
  [maximizable]="true"
  [draggable]="true"
>
  <div class="log-container">

    <div class="row">
      <div class="col-xl-6 mb-2">
        <div class="log-filter-label">
          <strong>Aksiyonlar</strong>
          <div class="log-mathed-badge" coreTooltip="Eşleşen Aksiyon Sayısı">{{ filters.matchedActions }}</div>
        </div>
        
        <div>
          <p-multiSelect [(ngModel)]="filters.selectedActions" [options]="filters.actions" (onChange)="updateData()" [showClear]="true"></p-multiSelect>
        </div>
      </div>
      <div class="col-xl-6 mb-2">
        <div class="log-filter-label">
          <strong>Kullanıcılar</strong>
          <div class="log-mathed-badge" coreTooltip="Eşleşen Kullanıcı Sayısı">{{ filters.matchedUsers }}</div>
        </div>
        
        <div>
          <p-multiSelect [(ngModel)]="filters.selectedUsers" [options]="filters.users" (onChange)="updateData()" (onClear)="updateData()" [showClear]="true"></p-multiSelect>
        </div>
      </div>
    </div>

    <div *ngIf="!data?.logs?.length" class="no-logs">
      <div class="no-logs-icon">📝</div>
      <p>{{ "case.timeline.no-log" | translate }}</p>
    </div>
    <p-timeline [value]="data?.logs" align="alternate">
      <ng-template pTemplate="marker" let-event>
        <span class="custom-marker">{{ event.index }}</span>
      </ng-template>
      <ng-template pTemplate="content" let-log>
        <div class="log-enty">
          <app-core-accordion
            [style]="{
              'box-shadow': 'rgba(0, 0, 0, 0.2) 0px 4px 10px',
              'border-radius': '15px'
            }"
            [headerStyle]="{ color: '#cc443c' }"
            [contentStyle]="{ padding: '0px' }"
          >
            <ng-template #accordionHeader>
              <div
                style="
                  width: 98%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div>{{ log?.action }}</div>
                <div>
                  <div>
                    {{ log?.user?.firstName }} {{ log?.user?.lastName }}
                  </div>
                  <div>
                    {{ log?.date | dateFormat : true }}
                  </div>
                </div>
              </div>
            </ng-template>
            <div class="changes" *ngFor="let change of log.changes">
              <div class="change-label">{{ change?.label }}</div>

              <ng-container *ngIf="!change.isArray">

                <div class="array-changes">
                  <div class="removed-values" *ngIf="change.oldValue">
                    <div class="change-subtitle">
                      {{ "case.timeline.old-value" | translate }}
                    </div>
                    <div class="value-chip">
                      {{ change.oldValue }}
                    </div>
                  </div>
                  <div class="added-values" *ngIf="change.newValue">
                    <div class="change-subtitle">
                      {{ "case.timeline.new-value" | translate }}
                    </div>
                    <div class="value-chip">
                      {{ change.newValue }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="change?.isArray">
                <div class="array-changes">
                  <div
                    class="removed-values"
                    *ngIf="change?.removedValueArray?.length"
                  >
                    <div class="change-subtitle">
                      {{ "case.timeline.removed-values" | translate }}
                    </div>
                    <div
                      class="value-chip"
                      *ngFor="let value of change?.removedValueArray"
                    >
                      {{ value }}
                    </div>
                  </div>
                  <div
                    class="added-values"
                    *ngIf="change?.addedValueArray?.length"
                  >
                    <div class="change-subtitle">
                      {{ "case.timeline.added-values" | translate }}
                    </div>
                    <div
                      class="value-chip"
                      *ngFor="let value of change?.addedValueArray"
                    >
                      {{ value }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </app-core-accordion>
        </div>
      </ng-template>
    </p-timeline>
  </div>
</p-dialog>
